/**
 * Copyright 2025 Amazon.com, Inc. and its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *   http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

export default class ObjectExt {
  static exists(obj) {
    return obj !== undefined && obj !== null;
  }

  static checkArgument(condition, message) {
    if (!condition) {
      throw TypeError(message);
    }
  }

  static checkExists(obj, message) {
    if (ObjectsExt.exists(obj)) {
      throw TypeError(message);
    }
  }
}
